( function () {
	'use strict';

	function ObsDeleteModalController ( logger, $modalInstance, apiService, observationId ) {
		var self = this;

		self.loading       = false;
		self.observationId = observationId;
		self.okToDeleteText = '';

		function activate () {
			logger.info( 'Obs Delete Modal.' );
		}

		function cancelDelete () {
			$modalInstance.dismiss();
		}

		function confirmDelete () {
			self.loading  = true;

			apiService.deleteObservation.delete( {
				'observationId' : self.observationId
			}, function () {
				$modalInstance.close();
				self.loading = false;
			} );
		}

		function okToDelete () {
			return self.okToDeleteText === 'DELETE';
		}

		self.confirmDelete = confirmDelete;
		self.cancelDelete  = cancelDelete;
		self.okToDelete    = okToDelete;

		activate();
	}

	angular
		.module( 'app.observations' )
		.controller( 'ObsDeleteModalController', ObsDeleteModalController );

	ObsDeleteModalController.$inject = [ 'logger', '$modalInstance', 'apiService', 'observationId' ];
} )();
